export default __webpack_public_path__ + "map-marker.png";